import TermsContainer from "./TermsContainer";

export default TermsContainer;